import { render, staticRenderFns } from "./PlacementsEndComponent.vue?vue&type=template&id=d8f20770&"
import script from "./PlacementsEndComponent.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports